import { useMemo } from 'react';
import { Consent, ServiceRequest, Specimen } from '@medplum/fhirtypes';
import { MedplumClient } from '@medplum/core';
import { useGenericResourceSearch } from '@/hooks/useGenericResourceSearch';
import {
  ORDER_SEARCH_DEFAULTS,
  orderSearchConfig,
  OrderBundleData,
  type OrderSearchParams,
} from '../orders/orderSearchConfig';

export type { OrderSearchParams };
export { ORDER_SEARCH_DEFAULTS };

const EMPTY_SPECIMENS = new Map<string, Specimen[]>();
const EMPTY_CONSENTS = new Map<string, Consent>();

export function useOrderSearch(medplum: MedplumClient, patientId?: string) {
  const baseSearch = useGenericResourceSearch<
    OrderSearchParams,
    ServiceRequest
  >(medplum, orderSearchConfig, patientId);

  const bundleData = baseSearch.bundleData as OrderBundleData | null;

  return useMemo(
    () => ({
      ...baseSearch,
      specimens: bundleData?.specimens ?? EMPTY_SPECIMENS,
      consents: bundleData?.consents ?? EMPTY_CONSENTS,
    }),
    [baseSearch, bundleData]
  );
}
